.container {
  opacity: 0;
  transform: scale(0);
  transition:
    transform 200ms,
    opacity 200ms;

  &:not([data-hide]) {
    animation: agentChatFadeIn 250ms ease forwards;
    animation-delay: 300ms;
    animation-iteration-count: 1;
  }

  &[data-hide] {
    opacity: 0;
    transform: scale(0);
  }
}

.actionIcon {
  transition:
    box-shadow 200ms,
    transform 200ms,
    opacity 200ms,
    background-color 200ms;

  box-shadow: var(--mantine-shadow-lg);
  border: solid 1px var(--mantine-color-disabled-border) !important;

  &:hover {
    > * {
      transform: rotate(90deg);
    }
  }
}

[data-mantine-color-scheme="dark"] .actionIcon {
  background-color: var(--mantine-color-dark-9);
}

@keyframes agentChatFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0);
  }
  70% {
    opacity: 1;
    transform: translateY(3px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}
